import { AxiosResponse } from 'axios';
import BaseService from "@/services/BaseService";
import ServiceResponseEntity from './response-models/ServiceResponseEntity';
import LoginModel from "@/models/LoginModel";
import User from "@/models/User";
import LoginResponse from './response-models/LoginResponse';
export default class LoginService extends BaseService<any> {
    public constructor() {
        super("Afiliado");
    }

    public async login(loginModel: LoginModel): 
    Promise<AxiosResponse<LoginResponse<User>>> {
        return this.post('Login', loginModel);
    }

   public async getUuidV4Id(): Promise<AxiosResponse<{ sessionId: string  }>> {
        return this.get('GetUuidV4Id');
        
    }
}